/**
 * Shared column geometry for the browser list view. The column header
 * (`HomeBrowserList`), the item rows (`HomeBrowserListRow`), and the folder
 * rows (`BrowserFolderRow`) must agree on widths and container-query shed
 * points or the columns drift out of alignment — so they all read from here.
 *
 * Location, Type and Size shed as the list narrows (an open right pane, a
 * small window) — in that order. The Name column and the trailing Modified
 * column never shed — Modified doubles as the actions cell: it shows the
 * timestamp at rest and swaps to the hover Open pill + kebab, so it must
 * always be mounted.
 */
export const BROWSER_LIST_COL = {
  /** Full-width-mode-only columns (main's old workspace files list had
   *  Type; the reading column doesn't earn their keep). Doubly gated: the
   *  ancestor `[data-browser-wide]` stamp (`HomeSurface`) restricts them to
   *  wide mode, and the container query still sheds them when a wide
   *  browser is squeezed narrow. */
  location: "hidden w-36 shrink-0 @4xl:[[data-browser-wide]_&]:block",
  type: "hidden w-24 shrink-0 @3xl:[[data-browser-wide]_&]:block",
  size: "hidden w-16 shrink-0 @lg:block",
  /** Trailing column, flush with the table's edge. w-28 fits the longest
   *  relative timestamps ("11 months ago"), the "Last updated" header + sort
   *  glyph, and the Open pill + kebab it swaps to on hover. */
  modified: "w-28 shrink-0 whitespace-nowrap",
} as const;
